import "./mission.css";

import { missionTitle, missionDescription } from "./text";
import Reveal from "../../utils/Reveal";

import imgM from "../../../assets/images/airplaneHalf.jpg";

const Mission = () => {
  return (
    <div className="container mission-section pt-1 pb-5">
      <div className="row d-flex flex-wrap mission-wrapper">
        <div className="col-lg-12">
          <div className="row d-flex flex-wrap">
            <div className="col-sm-12 col-lg-6 order-2 order-md-1">
              <img src={imgM} alt="" className="w-100 rounded img-fluid" />
            </div>
            <div className="col-sm-12 col-lg-6 order-1 order-md-2 mission-description">
              <Reveal animationType="fadeInLeft">
                <div className="section-card">
                  <h2
                    className="mb-4"
                    style={{ color: "rgba(0, 74, 173, 0.85)" }}
                  >
                    {missionTitle}
                  </h2>
                  <p className="fs-17">
                    {" "}
                    {missionDescription
                      .split("\n")
                      .filter((line) => line.trim() !== "")
                      .map((line, index) => (
                        <p key={index}>{line.trim()}</p>
                      ))}
                  </p>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
